// src/utils.ts
var access = (v) => typeof v === "function" ? v() : v;
var afterPaint = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

export { access, afterPaint };
